import { Alert, Box } from '@mui/material'

interface IProps {
    message: string
}

export default function DigitacaoErrorOverlay({ message }: IProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
            }}
        >
            <Alert
                severity="error"
                sx={{
                    width: 'fit-content',
                }}
            >
                {message ?? 'Erro ao carregar dados'}
            </Alert>
        </Box>
    )
}
